import axios from 'axios';

import store from '@/store';
import baseConfig from '_config';
import sessionService from '_services/common/sessionService';

const axiosInterceptor = () => {
  let exceptions = ['oauth/access_token'];

  exceptions = exceptions.map(e => `${baseConfig.API_URL}${e}`);

  // Add a request interceptor
  axios.interceptors.request.use(config => {
    const token = sessionService.getLocalData('_token');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (!exceptions.includes(config.url)) {
      const requestKey = `${config.url}_${Date.now()}`;
      const controller = new AbortController();

      config.signal = controller.signal;

      store.commit('setAbortController', { key: requestKey, controller });
      store.commit('setActiveCancelKey', requestKey);
    }

    if (!exceptions.includes(config.url)) {
      if (!store.state.toggle.progress) {
        store.dispatch('toggle', 'progress');
      }
    }
    return config;
  });

  // Add a response interceptor
  axios.interceptors.response.use(
    response => {
      store.commit('clearAbortController', response.config.url);

      if (!exceptions.includes(response.config.url)) {
        if (store.state.toggle.progress) {
          store.dispatch('toggle', 'progress');
        }
      }
      return response;
    },
    err => {
      // if the progress is set to true before
      // reset the state
      if (store.state.toggle.progress) {
        store.dispatch('toggle', 'progress');
      }

      if (axios.isCancel(err)) {
        err._isUserCancellation = true;
      }

      if (err.config) {
        store.commit('clearAbortController', err.config.url);
      }

      return Promise.reject(err);
    },
  );
};

export default axiosInterceptor;
